// extracted by mini-css-extract-plugin
module.exports = {"custonCheckbox":"EnableCompanyAlisaField_custonCheckbox__18pZD"};